import {
  IMedia,
  IMediaUpload,
  ISearchMediaReq,
  ISearchMediaRes,
} from '../interfaces/media';
import * as baseAdapter from './baseAdapter';

export const getMedia = async (id: number) => {
  const ret = await baseAdapter.get<IMedia>('/media/get/' + id);
  return ret;
};

export const searchMedias = async (req: ISearchMediaReq) => {
  const ret = await baseAdapter.post<ISearchMediaRes>('/media/gets', req);
  return ret;
};

export const uploadMedia = async (data: Partial<IMediaUpload>) => {
  const ret = await baseAdapter.postForm('/media/upload', data);
  return ret;
};

export const downloadMedia = async (id: number) => {
  const ret = await baseAdapter.download('/media/download/' + id);
  return ret;
};

export const deleteMedia = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/media/${id}`);
  return ret;
};
